var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "perspective-lower-bar-input-container" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model:value",
          value: _vm.distance,
          expression: "distance",
          arg: "value"
        }
      ],
      class: { "bad-data": _vm.badData },
      attrs: { id: "distance", type: "number", placeholder: "Длина, м" },
      domProps: { value: _vm.distance },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.distance = $event.target.value
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }